import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


import { useDateFormat } from "@vueuse/core";
import { get } from "@vueuse/core";
import { TIME_FORMAT } from "@/clinic/typings/constants/direct-message";

type IMessageShowTime = {
  date: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'show-time',
  props: {
    date: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, _toDisplayString(__props.date ? _unref(get)(_unref(useDateFormat)(__props.date, _unref(TIME_FORMAT))) : ""), 1))
}
}

})